import styled from "styled-components";

export const EmptySearchStateStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;

  .empty-search-container {
    text-align: center;
    max-width: 600px;
    width: 100%;
  }

  .search-icon-large {
    font-size: 64px;
    color: ${(props) => props.theme.colors.primary};
    opacity: 0.3;
    margin-bottom: 24px;

    .anticon {
      display: inline-block;
    }
  }

  .empty-search-title {
    font-size: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
    margin-bottom: 12px;
    font-family: 'Poppins', sans-serif;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }

  .empty-search-subtitle {
    font-size: 14px;
    color: ${(props) => props.theme.colors.primary};
    opacity: 0.6;
    margin-bottom: 32px;
    font-family: 'Poppins', sans-serif;

    @media (max-width: 768px) {
      font-size: 13px;
    }
  }

  .centered-search-box {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;

    @media (max-width: 600px) {
      flex-direction: column;
      gap: 16px;
    }
  }

  .centered-search-input {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    background: ${(props) => props.theme.background.primary5};
    border: 0.6px solid #FFFFFF33;
    color: ${(props) => props.theme.colors.primary} !important;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;

    &:hover, &:focus {
      border-color: #007AFF;
      background: ${(props) => props.theme.background.primary5};
    }

    input {
      background: transparent !important;
      color: ${(props) => props.theme.colors.primary} !important;
      font-family: 'Poppins', sans-serif;

      &::placeholder {
        color: ${(props) => props.theme.colors.primary} !important;
        opacity: 0.5;
      }
    }

    @media (max-width: 600px) {
      width: 100%;
    }
  }

  .centered-search-button {
    height: 48px;
    padding: 0 32px;
    border-radius: 8px;
    background: #007AFF;
    border: none;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    transition: all 0.2s;

    &:hover, &:focus {
      background: #0066DD;
      border: none;
    }

    @media (max-width: 600px) {
      width: 100%;
    }
  }
`;

